export default "__VITE_ASSET__dff8e1fa__"